import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { filterExcelSettlement } from 'redux/settlement-credit/excel'
import { ExportExcel } from 'tools/functions/ExportMyExcel'
import { getDay, getPrice } from 'tools/functions/Methods'
import { CreditColumns } from '../CreditColumns'

export default function useExportExcel(totalItems) {
  const [excelLoading, setLoading] = useState(false)
  const { filter } = useSelector((state: any) => state.creditSettlement)
  const totalExcel = Math.ceil(totalItems / 100)
  const dispatch = useDispatch()
  async function exportExcel() {
    try {
      setLoading(true)
      for (let i = 0; i < totalExcel; i++) {
        const result = await dispatch(
          filterExcelSettlement({
            ...filter,
            pageSize: 100,
            pageNumber: i + 1,
          }) as any
        ).unwrap()
        ExportExcel({
          data: convertExcel(result.payload.content),
          columns: CreditColumns,
        })
      }
      setLoading(false)
      //   }
    } catch {
      setLoading(false)
    }
  }

  return { exportExcel, excelLoading }
}

function convertExcel(settlementData) {
  let data = settlementData?.map((item: any) => {
    return {
      ...item,
      creditAmount: getPrice(item.creditAmount),
      hubName: item.creditRecipientHub?.name,
      settlementMonth:
        !!item.creditValidTo &&
        item.creditValidTo.year + '/' + item.creditValidTo.month,
      creditValidTo: !!item.creditValidTo && getDay(item.creditValidTo),
      settlementDate: !!item.settlementDate && getDay(item.settlementDate),
      creditBalance: getPrice(item.creditBalance),
      // remainCredit: getPrice(item.creditAmount - item.usedCredit),
      receiveCredit: item.creditorHub?.name,
      totalPayment: getPrice(item.totalPayment),
      settledAmount: getPrice(item.settledAmount),
      settlementStatus:
        item.settlementStatus === 1 ? 'پرداخت شده' : 'در انتظار پرداخت',
      usedCredit: item.findAllByConsignmentPriceFromHub.useCredit,
      tableusedCredit: getPrice(item.findAllByConsignmentPriceFromHub.useCredit),
      insurance: getPrice(item.findAllByConsignmentPriceFromHub?.insurance),
      // totalPayment: getPrice(item.totalPayment),
      totalPayable: getPrice(
        item?.findAllByConsignmentPriceFromHub?.totalPayable
      ),
      hubShareAmount: getPrice(
        item?.findAllByConsignmentPriceFromHub?.hubShareAmount
      ),
      percentage: item.findAllByConsignmentPriceFromHub?.percentage,
    }
  })
  return data
}
